import toastHTML from './toast.html';
import toastContainerHTML from './toast-container.html';
import {htmlToElement, triggerEvent} from '../functions';

let toastContainer = null;

function getContainer() {
    if (toastContainer !== null) {
        return toastContainer;
    }

    const container = htmlToElement(toastContainerHTML);

    toastContainer = container.getElementsByClassName('toast-container')[0];

    document.body.appendChild(container);

    return toastContainer;
}

const COLOR_MAP = Object.freeze({
    success: 'text-success',
    warning: 'text-warning',
    danger: 'text-danger',
    brand: 'text-brand-600',
    info: 'text-blue-600',
});

function colorForIcon(color) {
    if (COLOR_MAP[color]) {
        return COLOR_MAP[color];
    }

    return COLOR_MAP.success;
}

export function toast(options) {
    const toast = htmlToElement(
        toastHTML
            .replace('__ICON__', `${options.icon || 'fa-circle-check'} ${colorForIcon(options.color)}`)
            .replace('__TEXT__', options.text)
            .replace('__TITLE__', options.title)
    );

    if (options.onOpened) {
        toast.addEventListener('opened', options.onOpened);
    }

    if (options.onClosed) {
        toast.addEventListener('closed', options.onClosed);
    }

    toast.addEventListener('closed', () => setTimeout(() => toast.remove(), 1000));

    getContainer().prepend(toast);

    window.requestAnimationFrame(() => triggerEvent(toast, 'open'));

    setTimeout(() => triggerEvent(toast, 'close'), options.timeout || 4000);
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.TOASTS) {
        window.TOASTS.forEach(toast);
    }
});
